import { useContext } from 'react'
import { Box, Container } from '@mui/material'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import Header from '../Header'
import Footer from '../Footer'
import { Context } from '../../context/AuthContext'

/** Cor do cabeçalho das tabelas — sincronizada com o tema da empresa. */
export let colorTableDefault = '#3D5D84'
export let colorButton = '#1976d2'

const TemplateDefault = ({ children }) => {
  const {
    colorPrimary,
    colorSecondary,
    colorMenu,
    letterPrimary,
    letterSecondary,
    fontColorMenuSecondary,
  } = useContext(Context)

  colorTableDefault = colorPrimary
  colorButton = colorSecondary

  const theme = createTheme({
    palette: {
      primary: { main: colorPrimary, contrastText: '#FFFFFF' },
      secondary: { main: colorSecondary, contrastText: '#FFFFFF' },
      menu: { main: colorMenu, contrastText: letterSecondary },
      text: { primary: letterPrimary, secondary: letterSecondary },
      buttons: { main: colorSecondary, contrastText: fontColorMenuSecondary },
      chip: { main: colorSecondary, contrastText: letterSecondary },
    },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: {
        defaultProps: { color: 'primary' },
        styleOverrides: { root: { textTransform: 'none', fontWeight: 500 } },
      },
      MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    },
  })

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Container
          maxWidth={false}
          sx={{ width: '100%', flexGrow: 1, p: { xs: 1, md: 4 }, pt: { xs: 2, md: 3 } }}
        >
          {children}
        </Container>
        <Footer />
      </Box>
    </ThemeProvider>
  )
}

export default TemplateDefault
